<template>
  <div class="parent-box">
    <h2>月卡会员说明</h2>
    <p>
      1.开通月卡后，可立即领取一张满6减6优惠券，期限内后续每天可在月卡页面领取一张优惠券，
    </p>
    <p>2.月卡会员支持重复购买，会员将根据购买类型增长到期时间；</p>
    <p>3.领取方式为手动领取，如今天没有领取，后续无法补领；</p>
    <p>
      4.<span
        >月卡会员每天领取的满6减6优惠券有效期为1天，请领取后尽快使用，过期后无法返还；</span
      >
    </p>
    <p>5.此产品为虚拟商品，一经出售概不退换，请购买前根据实际需求是否开通；</p>
    <p>注意：未成年用户将无法使用该功能</p>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { monthCardCouponRecord } from "@/api/yzuser.js";
import { setToken, getToken, getUid } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
export default {
  name: "monthCardDesc",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      getLists: [],
    });
    onMounted(() => {});
    return {
      state,
    };
  },
};
</script>
<style scoped="scoped">
.parent-box {
  height: 100vh;
  width: 100vw;
  background-color: #161b1f;
  padding-left: 32px;
  padding-right: 32px;
  color: #fff;
  overflow: auto;
  padding-bottom: 120px;
}

.parent-box h2 {
  margin-bottom: 32px;
  font-size: 32px;
}
.parent-box p {
  margin-bottom: 10px;
}
.parent-box span {
  color: #ff6666;
}
</style>
